import type { Course, QuizConfig, QuizQuestion } from './types'

export const DEFAULT_PASSING_SCORE = 70

export function getQuizConfig(course?: Course | null): QuizConfig {
  return course?.quizConfig ?? {}
}

export function getCoursePassingScore(course?: Course | null): number {
  return getQuizConfig(course).passingScore ?? DEFAULT_PASSING_SCORE
}

export function getCourseQuestions(course?: Course | null): QuizQuestion[] {
  return course?.quizConfig?.questions ?? []
}
